// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__135IJ","range":"MonthRangeSwitch_range__3pWoo","disabled":"MonthRangeSwitch_disabled__1FLy2"};